var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AbstractEditable from './abstract';
var DateTimeEditable = /** @class */ (function (_super) {
    __extends(DateTimeEditable, _super);
    function DateTimeEditable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateTimeEditable.prototype.render = function () {
        var input_date = this.getElement().querySelector('[name=date]');
        var input_hours = this.getElement().querySelector('[name=time_hours]');
        var input_minutes = this.getElement().querySelector('[name=time_minutes]');
        var input_seconds = this.getElement().querySelector('[name=time_seconds]');
        document.body.classList.add('ac-jqui');
        DateTimeEditable.createSelectHours(input_hours, this._args.timeformat);
        DateTimeEditable.createSelectIncementalOptions(input_minutes);
        DateTimeEditable.createSelectIncementalOptions(input_seconds);
        jQuery(input_date).datepicker({
            dateFormat: 'yy-mm-dd',
            changeYear: true,
            showButtonPanel: true,
            firstDay: this._args.weekstart,
        });
    };
    DateTimeEditable.prototype.close = function () {
        document.body.classList.remove('ac-jqui');
        _super.prototype.close.call(this);
    };
    DateTimeEditable.prototype.valueToInput = function (value) {
        if (!value) {
            return;
        }
        var DateTime = new Date(value.replace(/-/g, "/"));
        if (isNaN(DateTime.getTime())) {
            return;
        }
        this.getElement().querySelector('[name=date]').value = DateTime.getFullYear() + '-' + ('0' + (DateTime.getMonth() + 1)).slice(-2) + '-' + ('0' + DateTime.getDate()).slice(-2);
        this.getElement().querySelector('[name=time_hours]').value = ('0' + (DateTime.getHours())).slice(-2);
        this.getElement().querySelector('[name=time_minutes]').value = ('0' + (DateTime.getMinutes())).slice(-2);
        this.getElement().querySelector('[name=time_seconds]').value = ('0' + (DateTime.getSeconds())).slice(-2);
    };
    DateTimeEditable.prototype.getValue = function () {
        var date = this.getElement().querySelector('[name=date]').value;
        var hours = this.getElement().querySelector('[name=time_hours]').value;
        var minutes = this.getElement().querySelector('[name=time_minutes]').value;
        var seconds = this.getElement().querySelector('[name=time_seconds]').value;
        if (!date || !hours || !minutes || !seconds) {
            return false;
        }
        return date + " " + hours + ":" + minutes + ":" + seconds;
    };
    DateTimeEditable.prototype.getTemplate = function () {
        var input = this._template.form.input('date', '', { placeholder: 'yyyy-mm-dd', autocomplete: 'nope' }).outerHTML;
        return "\n\t\t\t" + input + "\n\t\t\t<div class=\"input__time\">\n\t\t\t\t<select name=\"time_hours\"></select>\t\t\t\t\n\t\t\t\t<select name=\"time_minutes\"></select>\t\t\t\t\n\t\t\t\t<select name=\"time_seconds\"></select>\t\t\t\t\n\t\t\t</div>\n\t\t";
    };
    DateTimeEditable.prototype._setDefaults = function () {
        this._defaults.type = 'datetime';
        this._defaults.weekstart = 0;
        this._defaults.timeformat = 12;
    };
    DateTimeEditable.createSelectHours = function (select, timeformat) {
        for (var number = 0; number < 24; number++) {
            var option = document.createElement('option');
            var _number = ('0' + number).slice(-2);
            option.setAttribute('value', _number);
            option.text = (12 === timeformat) ? DateTimeEditable.formatAMPM(_number) : _number;
            select.append(option);
        }
    };
    DateTimeEditable.formatAMPM = function (hours) {
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        return hours + ' ' + ampm;
    };
    DateTimeEditable.createSelectIncementalOptions = function (select, start, end) {
        if (start === void 0) { start = 0; }
        if (end === void 0) { end = 60; }
        for (var number = start; number < end; number++) {
            var option = document.createElement('option');
            var _number = ('0' + number).slice(-2);
            option.setAttribute('value', _number);
            option.text = _number;
            select.append(option);
        }
    };
    return DateTimeEditable;
}(AbstractEditable));
export default DateTimeEditable;
